module.exports = __webpack_public_path__ + "img/einlagern.330bf281.svg";